import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';
import { GameGroup } from '../../entities/gamegroup';
import { Ticket } from '../../providers/user';
import { NavParams } from 'ionic-angular';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({
  selector: 'page-statment',
  templateUrl: 'statment.html'
})

export class StatmentPage extends MainPage {
    public gameGroups: GameGroup[];
    public selectedGroup: GameGroup;
    public betGroup: GameGroup;
    public selectedTicket: Ticket;
    public total: number;
    public tickets: Ticket[];
    public paramTicket: string = "";
    public paramGroupId: number = 0;
    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public contestService: ContestService,
        public userService: UserService, protected alertController: AlertController,
        public navParams: NavParams,
        protected appCtrl: App) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.total = 0;
        this.loadPage();
    }

    public loadPage(): void {
        try {
            this.paramTicket = this.navParams.get("ticket");
            this.paramGroupId = this.navParams.get("groupId");
        }
        catch{}
        this.userService.getAllByChampionship().then((data: Ticket[]) => {
            this.ticketsLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public ticketsLoaded(data: Ticket[]) {
        this.tickets = data;
        for(var i=0; i<this.tickets.length; i++) {
            if ((!this.isNull(this.paramTicket)) && (this.paramTicket.length > 0)) {
                if (this.tickets[i].Fullname === this.paramTicket) {
                    this.selectedTicket = this.tickets[i];
                    break;
                }
            }
            else if (this.tickets[i].TicketId == this.CurrentTicket.TicketId) {
                this.selectedTicket = this.tickets[i];
                break;
            }
        }
        this.loadGroups();
    }

    public loadGroups(): void {
        this.contestService.getGroups().then((data: GameGroup[]) => {
            this.groupsLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public groupsLoaded(gameGroup: GameGroup[]): void {
        this.gameGroups = gameGroup;
        for(var i=0; i<this.gameGroups.length; i++) {
            if (this.paramGroupId > 0) {
                if ((!this.isNull(this.paramGroupId)) && (this.gameGroups[i].GameGroupId === this.paramGroupId)) {
                    this.selectedGroup = this.gameGroups[i];
                    break;
                }
            }
            else if (this.gameGroups[i].IsDefault) {
                this.selectedGroup = this.gameGroups[i];
                break;
            }
        }
        this.getStatment();
    } 

    public getStatment(): void {
        if ((!this.isNull(this.selectedTicket)) && (!this.isNull(this.selectedGroup))) {
            this.contestService.getGamesToStatment(this.selectedTicket.TicketId, this.selectedGroup.GameGroupId).then((data: GameGroup[]) => {
                this.statmentLoaded(data);
            }).catch((err) => {
                this.getError(<ErrorResult>err);
              }); 
        }
    }

    public statmentLoaded(data: GameGroup[]) {
        this.total = 0;
        if (data.length > 0) {
            this.betGroup = data[0];
            if (!this.isNull(this.betGroup)) {
                for(var i=0; i<this.betGroup.Bets.length; i++) {
                    this.total += this.betGroup.Bets[i].Points;
                }
            }
        }
        else {
            this.betGroup = new GameGroup();
        }
    }

    public requestChanged(): void {
        this.getStatment();
    }

    public compareGroup(g1: GameGroup, g2:GameGroup): boolean {
        return g1.Fullname === g2.Fullname;
    }

    public compareTicket(t1: Ticket, t2: Ticket): boolean {
        return t1.TicketId === t2.TicketId;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contest/statment.ts